<template>
    <main id="form" :class="{ hidecode: !hidecode }" class="relative">
      <NoticeView v-if="open" @close="open = false" />
      <img
        src="../assets/images/pepite1.png"
        class="sm:hidden w-[15vw] absolute top-[75px] -right-[3vw] rotate-[270deg] z-50"
        style="align-items: center"
      />
      <img
        src="../assets/images/pepite2.png"
        class="sm:hidden w-[5vw] absolute top-[165px] left-[3vw] rotate-[20deg] z-50"
        style="align-items: center"
      />
  
      <img
        src="../assets/images/noisette.png"
        class="sm:hidden w-[10vw] absolute top-[395px] -left-[10px] rotate-[20deg] z-50"
        style="align-items: center"
      />
      <img
        src="../assets/images/noisette.png"
        class="sm:hidden w-[10vw] absolute bottom-[15px] right-[20px] rotate-[20deg] z-50"
        style="align-items: center"
      />
      <img
        src="../assets/images/pepite2.png"
        class="sm:hidden w-[4vw] absolute -bottom-[20px] right-[15px] rotate-[20deg] z-50"
        style="align-items: center"
      />
      <div class="sm:mt-28 md:mt-16 w-full text-white">
        <h1
          class="font-veneer text-[5vw] leading-[5.5vw] sm:text-3xl text-white text-center my-2 sm:my-6 mt-8 sm:mt-0"
        >
          Pour participer, veuillez compléter<br />
          les informations ci-dessous :
        </h1>
      </div>
      <Form
        class="px-[9vw] sm:px-4"
        id="createForm"
        :form_id="formId"
        server="https://api-gabarit.promo.dev"
        v-on:results="getResult"
        v-on:form_submit_loading="onLoading"
        :hideError="hiderror"
        @on_error="showErrorForm"
        :relay="relay"
      />
    </main>
  </template>
  <script setup lang="ts">
  import router from "@/router";
  import { ref, onMounted, onBeforeUnmount } from "vue";
  import NoticeView from "@/components/NoticeView.vue";
  import { CURRENT_OPERATION_ID, formsForOperation } from "@/config/operations";

  const formId = formsForOperation(CURRENT_OPERATION_ID).CREATE;
  const hiderror = ref(true);
  const loading = ref(false);
  const error = ref(false);
  const relay = ref();
  const open = ref(false);
  let scrollTimeout;
  
  const onLoading = () => {
    loading.value = true;
  };
  
  const showErrorForm = (event) => {
    alert(event.error.message);
    loading.value = false;
    error.value = true;
  };
  
  const hidecode = ref(false);
  
  const getResult = (result) => {
    if (result && result.status) {
      // result.status = "GAGNE";
      sessionStorage.setItem("status", result.status);
      sessionStorage.setItem("_id", result._id);
      sessionStorage.setItem("code_unique", result.code_unique);
      sessionStorage.setItem("uid", result.uid);
      sessionStorage.setItem("email", result.email);
      sessionStorage.setItem("last_name", result.last_name);
      sessionStorage.setItem("first_name", result.first_name);
      router.push({ name: "form2" });
    } else {
      alert("Une erreur est survenue, veuillez réessayer plus tard.");
    }
  };
  
  onMounted(async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code_unique = urlParams.get("code_unique");
      const first_name = urlParams.get("first_name");
      const last_name = urlParams.get("last_name");
      const email = urlParams.get("email");
  
      if (code_unique) {
        window['code'] = code_unique;
      }
  
      setTimeout(() => {
        if (document.querySelector("#noticelink")) {
          document
            .querySelector("#noticelink")
            .addEventListener("click", (event) => {
              event.preventDefault();
              open.value = true;
            });
        }
      }, 1000);

      // Fix pour le dropdown Google Places lors du scroll
      const handleScroll = () => {
        // Fermer le dropdown Google Places pendant le scroll
        const pacContainer = document.querySelector('.pac-container');
        if (pacContainer) {
          pacContainer.style.visibility = 'hidden';
        }

        // Réafficher le dropdown après la fin du scroll
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (pacContainer) {
            pacContainer.style.visibility = 'visible';
          }
        }, 150);
      };

      // Ajouter le listener de scroll sur window et sur les conteneurs scrollables
      window.addEventListener('scroll', handleScroll, true);

      // Nettoyer les listeners lors de la destruction du composant
      const cleanup = () => {
        window.removeEventListener('scroll', handleScroll, true);
        clearTimeout(scrollTimeout);
      };

      // Stocker la fonction de nettoyage pour l'utiliser dans onBeforeUnmount si nécessaire
      window['__formScrollCleanup'] = cleanup;

      sessionStorage.clear();
  
      if (window['code']) {
        relay.value = {
          code_unique: window['code'],
          first_name: first_name,
          last_name: last_name,
          email: email,
        };
        hidecode.value = false;
      } else {
        hidecode.value = true;
      }
      console.log(0);
    } catch (e) {
      console.error(e);
    }
  });

  onBeforeUnmount(() => {
    // Nettoyer les listeners de scroll
    if (window['__formScrollCleanup']) {
      window['__formScrollCleanup']();
      delete window['__formScrollCleanup'];
    }
  });
  </script>
  
  <style>

.upload-btn-set{
  margin-top : -20px !important;
  margin-bottom : 30px !important;
}

  .hidecode .input_wrapper_code_unique {
    opacity: 0 !important;
    width: 0px !important;
    height: 0px !important;
    position: absolute !important;
    left: -10000px !important;
  }
  </style>
  